<template>
  <v-dialog v-model="modelIsOpen" persistent width="500">
    <v-card>
      <v-card-title style="font-weight:bolder; font-size:smaller">{{modelDialogTitle}}</v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <br />
        <div class="text--primary">
          <p v-html="modelText" />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <button type="button" class="btn btn-primary" @click="closeDialog">{{ modelDialogButtonText }}</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  // WrsSecurityDialog.vue
  export default {
    data() {
      return {
        isManuallyClosed: false,
      }
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      dialogTitle: {
        type: String,
        default: ""
      },
      dialogButtonText: {
        type: String,
        default: ""
      },
      messageText: {
        type: String,
        default: ""
      },
      homePage: {
        type: String,
        default: ""
      },
    },
    computed: {
      modelIsOpen: {
        get() {
          return this.isOpen && !this.isManuallyClosed;
        }
      },
      modelText: {
        get() {
          return this.messageText;
        }
      },
      modelDialogTitle: {
        get() {
          return this.dialogTitle;
        }
      },
      modelDialogButtonText: {
        get() {
          return this.dialogButtonText;
        }
      },
    },
    methods: {
      closeDialog() {
        this.isManuallyClosed = true;

        if (this.homePage != "") window.location.href = this.homePage;
      }
    }
  }
</script>

